import { lazyLoadAnalytics } from '../../../../Common/Resources/src_front/js/components/lazyLoadAnalytics';
import { pushengage } from './components/analytics/pushengage';
import { initMixpannel } from '../../../../Common/Resources/src_front/js/mixpannel/initMixpannel';
import { cookiebot } from './components/analytics/cookiebot';

document.addEventListener('DOMContentLoaded', function () {
    lazyLoadAnalytics(cookiebot);
    lazyLoadAnalytics(pushengage);
    initMixpannel();
});
